import React from 'react';
import {createPortal} from 'react-dom';
import ModalSimple from '../../../global/modal-simple';
import * as util from '../../../util';

// (i) button beside the "Enter promo code" header. The header renders inline (cart summary,
// payment step) and inside the "Promo Codes and Gift Cards" modal. The site's modal opener
// hides whichever modal is already open, so the note is rendered through a portal (a modal
// nested in a hidden modal is invisible) and, when opened from inside a modal, that modal is
// reopened once the note is dismissed.
class PromoInfo extends React.Component {
    private readonly modalId = `modal-promo-info-${Math.floor(Math.random() * 16777216)}`;
    private parentModalId: string | null = null;

    componentWillUnmount() {
        document.removeEventListener('keydown', this.onKeyDown);
    }

    open = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();
        e.stopPropagation();
        const parent = (e.currentTarget as HTMLElement).closest('.modal') as HTMLElement | null;
        this.parentModalId = parent && parent.id && parent.id !== this.modalId ? parent.id : null;
        if (this.parentModalId) {
            document.addEventListener('keydown', this.onKeyDown);
        }
        util.modal(this.modalId);
    };

    // Escape is handled globally (closes every modal), so the parent has to be restored here too.
    onKeyDown = (e: KeyboardEvent) => {
        if (e.key === 'Escape' || e.key === 'Esc') {
            this.restoreParent();
        }
    };

    restoreParent = () => {
        document.removeEventListener('keydown', this.onKeyDown);
        const id = this.parentModalId;
        this.parentModalId = null;
        if (id) {
            // ModalSimple closes all modals after calling this; reopen the parent afterwards.
            setTimeout(() => util.modal(id));
        }
    };

    render() {
        return (
            <>
                <button
                    type="button"
                    className="info-button"
                    aria-haspopup="dialog"
                    aria-controls={this.modalId}
                    aria-label="Promo code information"
                    onClick={this.open}
                >
                    <i
                        className="far fa-info-circle"
                        aria-hidden={true}
                    />
                </button>
                {createPortal(
                    <ModalSimple
                        id={this.modalId}
                        title="Promo Code"
                        maxWidth="480px"
                        close={this.restoreParent}
                    >
                        <p className="m-0">Please note: Only 1 promo code can be used per order.</p>
                    </ModalSimple>,
                    document.body,
                )}
            </>
        );
    }
}

export default PromoInfo;
